/*
 *  Copyright (c) 2023. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../../../theme/commonStyle";
import poaThumbnail from "../../../../../../assets/img/thumbnail/schufa_poa_thumbnail.jpg";

export const wbsColor = "#E61F00";
export const schufaCheckinStyles = {
  scrollToAnchor,
  formPaper: {
    padding: { xs: "20px 40px", md: "20px" },
  },
  gridSpaceEmail: {
    paddingRight: { md: "3rem" },
  },
  buttonContainer: {
    marginRight: "auto",
    marginLeft: "auto",
  },
  heading: {
    textAlign: "center",
    margin: "1rem",
  },
  wbsInfo: {
    textAlign: "center",
    margin: "1rem",
    color: wbsColor,
  },
  inFormHeading: {
    textAlign: "center",
    margin: "2rem 1rem 1rem",
  },
  classification: {
    width: "100%",
  },
  email: {
    width: "100%",
  },
  button: {
    color: "white",
    backgroundColor: wbsColor,
    "&:hover": { backgroundColor: wbsColor },
  },
  notInsuredMessage: {
    textAlign: "center",
    color: "#137f7b",
    margin: 1,
  },
  powerOfAttorneyPreview: {
    backgroundImage: "url(" + poaThumbnail + ")",
    height: "300px",
    width: "200px",
    backgroundRepeat: "no-repeat",
    margin: "0 auto",
    border: "1px solid #dedcdc",
    borderRadius: 5,
  },
  previewButton: {
    borderTop: "1px solid #dedcdc",
    borderBottom: "1px solid #dedcdc",
    borderRadius: 0,
    padding: ".875rem",
    background: "rgba(255, 255, 255, 0.6)",
    "&:hover": {
      backgroundColor: "rgba(200, 200, 200, 0.8)",
      cursor: "pointer",
    },
  },
  errorMessage: {
    textAlign: "center",
    margin: 1,
    color: "#d32f2f",
    fontSize: "0.75rem",
    fontWeight: 400
  }
};
